// ═══════════════════════════════════════════════════════════════════════════════
// MSAL (Microsoft Entra ID) CONFIG
// ═══════════════════════════════════════════════════════════════════════════════
// Gates Proxy behind PPUSA (@proximityparks.com) SSO.
// Client/tenant IDs are not secrets — they're public identifiers baked into the
// browser bundle. The actual security is enforced by Entra ID (tenant match +
// admin-consented delegated scopes).

import { LogLevel } from "@azure/msal-browser";

const TENANT_ID = "2d70db30-9148-4958-af32-65c0a5062eb0";
const CLIENT_ID = "3d15bec1-b0b4-4777-86a2-2650eba1689d";

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    // Single-tenant authority — blocks non-PPUSA accounts at the IdP level.
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    // Use whatever origin the app is running from (handles prod, localhost, Vercel previews).
    // Each origin must be registered as a Redirect URI in the Azure App Registration.
    redirectUri: typeof window !== "undefined" ? window.location.origin : "https://proxy.proximityparks.com",
    postLogoutRedirectUri: typeof window !== "undefined" ? window.location.origin : "https://proxy.proximityparks.com",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // sessionStorage = token cleared when tab closes; use localStorage for "stay signed in".
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error("[MSAL]", message);
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scopes requested at sign-in. `Mail.Send` lets us send LOIs from the user's
// mailbox via /me/sendMail. `User.Read` lets us fetch the user's profile.
// Both are delegated permissions and require admin consent in the tenant.
//
// We deliberately don't override redirectUri here — the popup lands back at
// the app origin (already registered in Azure), and index.js detects
// window.opener to prevent the SPA from rendering inside the popup.
export const loginRequest = {
  scopes: ["User.Read", "Mail.Send", "Mail.Read.Shared", "Mail.ReadWrite.Shared", "Mail.Send.Shared"],
};

// Scopes used when silently acquiring a Graph access token for sendMail calls.
export const graphMailRequest = {
  scopes: ["Mail.Send", "Mail.Send.Shared"],
};

// Scopes used when reading / managing the shared acquisitions inbox.
export const graphInboxRequest = {
  scopes: ["Mail.Read.Shared", "Mail.ReadWrite.Shared", "Mail.Send.Shared"],
};
